import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const CATS = [
    { label: "T-Shirts", img: "/assets/CATEGORY_TSHIRTS.jpg", to: "/shop?category=T-Shirts" },
    { label: "Hoodies", img: "/assets/CATEGORY_HOODIES.jpg", to: "/shop?category=Hoodies" },
    { label: "Jackets", img: "/assets/CATEGORY_JACKETS.jpg", to: "/shop?category=Jackets" },
    { label: "Bottoms", img: "/assets/CATEGORY_BOTTOMS.jpg", to: "/shop?category=Bottoms" },
    { label: "Caps", img: "/assets/DROP_001_PRODUCT_P19_FRONT.jpg", to: "/shop?category=Accessories" },
];

export default function CategoryDeck() {
    const [order, setOrder] = useState(CATS.map((_, i) => i));

    const next = () => setOrder((o) => [...o.slice(1), o[0]]);
    const prev = () => setOrder((o) => [o[o.length - 1], ...o.slice(0, -1)]);

    return (
        <div data-testid="category-deck" data-cursor="DRAG" className="relative mx-auto h-[62vh] max-w-sm touch-pan-y md:hidden">
            {CATS.map((c, i) => {
                const pos = order.indexOf(i);
                const front = pos === 0;
                return (
                    <motion.div
                        key={c.label}
                        data-testid={`deck-card-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
                        drag={front ? "x" : false}
                        dragConstraints={{ left: 0, right: 0 }}
                        dragElastic={0.55}
                        onDragEnd={(e, info) => {
                            if (info.offset.x < -60) next();
                            else if (info.offset.x > 60) prev();
                        }}
                        animate={{
                            x: pos === 0 ? 0 : pos % 2 === 0 ? pos * 14 : pos * -14,
                            y: pos * 8,
                            scale: 1 - pos * 0.05,
                            rotate: pos === 0 ? 0 : pos % 2 === 0 ? pos * 1.6 : pos * -1.6,
                            opacity: pos > 3 ? 0 : 1,
                        }}
                        transition={{ type: "spring", stiffness: 260, damping: 26 }}
                        style={{ zIndex: CATS.length - pos }}
                        className="absolute inset-x-0 top-0 h-[54vh] overflow-hidden rounded-3xl border border-[rgba(10,10,10,0.12)] bg-[#ECEAE4] shadow-[0_30px_60px_-20px_rgba(0,0,0,0.9)]"
                    >
                        <img
                            src={c.img}
                            alt={`${c.label} category`}
                            loading="lazy"
                            draggable={false}
                            className="pointer-events-none h-full w-full object-cover"
                        />
                        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                        <div className="absolute bottom-0 left-0 right-0 flex items-end justify-between p-6">
                            <div>
                                <p className="font-display text-2xl font-extrabold uppercase tracking-tight text-[#F2F0EA]">
                                    {c.label}
                                </p>
                                {front && (
                                    <p className="mt-1 text-[8px] uppercase tracking-[0.3em] text-[rgba(242,240,234,0.55)]">
                                        Swipe to browse
                                    </p>
                                )}
                            </div>
                            {front && (
                                <Link
                                    data-testid={`deck-shop-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
                                    to={c.to}
                                    onClick={(e) => e.stopPropagation()}
                                    className="rounded-full bg-[#0A0A0A] px-4 py-2 text-[9px] font-bold uppercase tracking-[0.25em] text-[#F2F0EA]"
                                >
                                    Shop Now
                                </Link>
                            )}
                        </div>
                    </motion.div>
                );
            })}
        </div>
    );
}
